import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var SendDigitalProofsStatusCurrentStateInline;
(function (SendDigitalProofsStatusCurrentStateInline) {
    SendDigitalProofsStatusCurrentStateInline["PROCESSING"] = "PROCESSING";
    SendDigitalProofsStatusCurrentStateInline["FINISHED"] = "FINISHED";
    SendDigitalProofsStatusCurrentStateInline["NOT_INITIATED"] = "NOT_INITIATED";
})(SendDigitalProofsStatusCurrentStateInline || (SendDigitalProofsStatusCurrentStateInline = {}));
export var EmailTemplateType;
(function (EmailTemplateType) {
    EmailTemplateType["SEND_PRINT_PROOFS"] = "SEND_PRINT_PROOFS";
    EmailTemplateType["REQUEST_CREATIVES"] = "REQUEST_CREATIVES";
})(EmailTemplateType || (EmailTemplateType = {}));
export var CampaignPositionStatus;
(function (CampaignPositionStatus) {
    CampaignPositionStatus["READY_TO_PUSH"] = "READY_TO_PUSH";
    CampaignPositionStatus["CREATIVE_PENDING"] = "CREATIVE_PENDING";
    CampaignPositionStatus["CREATIVE_REQUESTED"] = "CREATIVE_REQUESTED";
    CampaignPositionStatus["CREATIVE_RECEIVED"] = "CREATIVE_RECEIVED";
    CampaignPositionStatus["READY"] = "READY";
    CampaignPositionStatus["PROOFS"] = "PROOFS";
    CampaignPositionStatus["FINISHED"] = "FINISHED";
    CampaignPositionStatus["ALL"] = "ALL";
    CampaignPositionStatus["DELETED"] = "DELETED";
    CampaignPositionStatus["AUTO_HIDDEN"] = "AUTO_HIDDEN";
    CampaignPositionStatus["MANUAL_HIDDEN"] = "MANUAL_HIDDEN";
})(CampaignPositionStatus || (CampaignPositionStatus = {}));
export var MotiveStatus;
(function (MotiveStatus) {
    MotiveStatus["MISSING"] = "MISSING";
    MotiveStatus["REQUESTED"] = "REQUESTED";
    MotiveStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    MotiveStatus["APPROVED"] = "APPROVED";
    MotiveStatus["REJECTED"] = "REJECTED";
    MotiveStatus["APPEARED"] = "APPEARED";
    MotiveStatus["ERROR"] = "ERROR";
})(MotiveStatus || (MotiveStatus = {}));
export var PushMode;
(function (PushMode) {
    PushMode["AUTO"] = "AUTO";
    PushMode["MANUAL"] = "MANUAL";
    PushMode["NONE"] = "NONE";
})(PushMode || (PushMode = {}));
export var Color;
(function (Color) {
    Color["BLACK_AND_WHITE"] = "BLACK_AND_WHITE";
    Color["COLOR"] = "COLOR";
    Color["NONE"] = "NONE";
})(Color || (Color = {}));
export var CreationType;
(function (CreationType) {
    CreationType["FIXED_SIZE"] = "FIXED_SIZE";
    CreationType["DYNAMIC_SIZE"] = "DYNAMIC_SIZE";
    CreationType["TEMPLATE"] = "TEMPLATE";
})(CreationType || (CreationType = {}));
